export const getInputWidthBasedOnValueLength = (value: string | undefined) => {
    return `${value?.length}ch`;
};
